<template>
  <div>
    <PartnerForm
      @save="onSaveForm"
    />
  </div>
</template>

<script type="text/javascript">
import PartnerForm from '@/components/Partners/PartnerForm.vue';
import { create } from '@/api/partners';
import { iwalyNotify } from '@/notify';

export default {
  name: 'PartnersNewPartner',
  components: { PartnerForm },
  methods: {
    async onSaveForm(e) {
      try {
        await create(e);
        iwalyNotify.success({
          text: 'Реферрал успешно создан',
        });
      } catch (err) {
        if (err?.response?.data?.errors) {
          const errors = err?.response?.data?.errors ?? {};
          const errString = Object.keys(errors).reduce((acc, key) => {
            acc.push(`${key}: ${errors[key]?.join(', ')}`);
            return acc;
          }, []).join('; ');
          iwalyNotify.error({
            text: errString,
          });
        } else {
          iwalyNotify.error({
            text: err,
          });
        }
      }
    },
  },
};
</script>
